module.exports = __webpack_public_path__ + "static/media/1018425.07f5ce07.png";